import { Controller } from "@hotwired/stimulus"

// Thin facade over window.ltAutomationService: it calls setupEventListeners("show"), which binds
// the decorator-rendered .delete-automation/.duplicate-automation/.automation-status-switch
// elements itself. The only behaviour that needs wiring here is deleteAutomation, invoked from the
// delete-confirmation modal (shared/_delete_modal.html.haml).
export default class extends Controller {
  connect() {
    window.ltAutomationService.setupEventListeners("show");
  }

  deleteAutomation(event) {
    window.ltAutomationService.deleteAutomation(event);
  }
}
